<!--公告-->
<template>
  <div class="scroll-notice">
    <div class="notice-wrapper d-flex align-items-center">
      <div class="notice-icon"></div>
      <div class="notice-main d-flex align-items-center text-ellipsis" @click="showNotic">
        <van-notice-bar scrollable :text="`${newLists.map(item => item.subject).join(' ')}`" />
      </div>
      <p class="notice-more" @click="$router.push('/message')">{{ $t('更多') }} ></p>
    </div>
    <!--弹窗公告-->
    <van-popup v-model:show="noticShow" class="notice-pup" @click-overlay.stop="close" @open="showdom = true"
      @closed="showdom = false" teleport="#app-container">
      <div class="dialog-notice" v-if="showdom">
        <div class="dialog-title-notice">
          <div class="title-main"></div>
        </div>
        <div class="dialog-content">
          <div class="dialog-main">
            <!--图片公告-->
            <template v-if="hasImgNotice.length">
              <van-swipe :autoplay="3000" lazy-render>
                <van-swipe-item v-for="(item) in hasImgNotice" :key="item.bulletin_id">
                  <van-image class="notice-swiper-img" :src="item.pic_addr" lazy-load :type="item.content_type" />
                </van-swipe-item>
              </van-swipe>
            </template>
            <!--文字公告-->
            <template v-if="notImgNotice.length">
              <van-collapse class="notice-collapse-box" v-model="notImgNoticeName">
                <template v-for="(item) in notImgNotice" :key="item.bulletin_id">
                  <template v-if="[3].includes(item.content_type)">
                    <a :href="item.content" target="_blank" class="d-block collapse-item notice-item"
                      :type="item.content_type">
                      <van-cell center class="" is-link :title="item.subject">
                        <template #icon>
                          <i class="notice-title-icon"></i>
                        </template>
                      </van-cell>
                    </a>
                  </template>
                  <template v-else>
                    <van-collapse-item center class="collapse-item notice-item" :title="item.subject"
                      :name="`${item.bulletin_id + ''}`">
                      <template #icon>
                        <i class="notice-title-icon"></i>
                      </template>
                      <div class="dialog-content-detail" :type="item.content_type" v-html="item.content"></div>
                    </van-collapse-item>
                  </template>
                </template>
              </van-collapse>
            </template>
          </div>
        </div>
        <template v-if="['themeKYMN'].includes(THEME)">
          <div class="notic-footer d-flex align-items-center justify-content-center">
            <p class="fz-14 text-ellipsis readed-txt" @click.stop="close" v-text="$t('我已了解')"></p>
          </div>
          <div class="notice-bottom">
            <van-checkbox shape="square" v-model="todayNoShow">{{ $t('今日不再展示') }}</van-checkbox>
            <van-icon class="notice-close" size="24" name="clear" color="#fff" @click.stop="close" />
          </div>
        </template>
        <template v-else>
          <div class="notic-footer d-flex align-items-center justify-content-between">
            <van-checkbox v-model="todayNoShow">{{ $t('今日不再展示') }}</van-checkbox>
            <p class="fz-14 text-ellipsis readed-txt" @click.stop="close" v-text="$t('我已了解')"></p>
          </div>
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script lang="ts">
import {
  getBannerAndNotice,
  isTodayTime,
  loadLastNotice,
  removeTodayTime,
  saveLastNotice,
  saveTodayTime
} from "/@/hooks/message";
import { computed, ref, watch } from "vue";
import { isApp } from "/@/kernel-mn/utils";

export default {
  name: "Notice",
  methods: { isApp },
  setup() {
    const { newLists } = getBannerAndNotice();
    const todayNoShow = ref(isTodayTime()); // 公告今日是否再次显示弹窗
    // 显示弹窗
    let noticShow = ref(false);
    let showdom = ref(false);
    // 弹窗的公告列表
    let noticDialog = computed(() => {
      if (newLists.value.length) {
        // @ts-ignore
        return newLists.value.filter(item => item.ma_id !== 8 && item.is_pop_up === 1);
      }
      return [];
    });
    // 带图片的弹窗公告 content_type 1文字 2图片 3链接
    let hasImgNotice = computed(() => {
      return noticDialog.value.filter(item => item.content_type === 2)
    });
    // 不带图片的弹窗公告
    let notImgNotice = computed(() => {
      return noticDialog.value.filter(item => item.content_type !== 2)
    });
    
    let notImgNoticeName = ref(['']);
    watch(newLists, nv => {
      if (nv && nv.length) {
        let bulletin_id = nv[0].bulletin_id ? nv[0].bulletin_id : ''; // 接口返回的最新公告ID
        let local_id = loadLastNotice();
        // @ts-ignore
        let bool = !!nv.length && !!nv.filter(i => i.is_pop_up === 1).length;
        if (+local_id === +bulletin_id) bool = false;
        // 今日不再展示为真
        if (todayNoShow.value) bool = false;
        noticShow.value = bool;
        if (bool) {
          const firstNotice = notImgNotice.value[0]?.bulletin_id
          notImgNoticeName.value = [`${firstNotice}`]
        }
        saveLastNotice(bulletin_id);
      }
    }, { immediate: true });
    // 显示公告弹窗
    const showNotic = () => {
      noticShow.value = true;

      const firstNotice = notImgNotice.value[0]?.bulletin_id
      notImgNoticeName.value = [`${firstNotice}`]

      todayNoShow.value = isTodayTime();
    };
    const close = () => {
      noticShow.value = false;
    };
    watch(todayNoShow, (nv) => {
      if (nv) {
        saveTodayTime();
      } else {
        removeTodayTime()
      }
    }, { flush: "post" });
    return {
      newLists,
      showNotic,
      noticDialog,
      hasImgNotice,
      notImgNotice,
      notImgNoticeName,
      noticShow,
      showdom,
      close,
      todayNoShow,
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-wrapper {
  height: px2rem(36);
  box-sizing: border-box;
  border-radius: px2rem(12);
  padding: 0 px2rem(12);
  background: var(--home-notice-bg);

  .notice-icon {
    width: px2rem(18);
    height: px2rem(18);
    margin-right: px2rem(4);
    flex-shrink: 0;
    background: var(--home-notice-icon) 0 0 / 100% 100% no-repeat;
  }

  .notice-main {
    flex: 1;
    height: 100%;
    line-height: px2rem(20);

    .van-notice-bar {
      width: 100%;
      height: px2rem(20);
      padding: 0;
      background: none;
      color: var(--text-color);
      font-size: px2rem(12);
    }

    .notice-swipe {
      height: px2rem(20);
      line-height: px2rem(20);
    }
  }

  .notice-more {
    padding: 0 px2rem(4);
  }
}

// 弹窗公告
.dialog-notice {
  width: px2rem(350);
  min-height: px2rem(420);
  max-height: 80vh;
  position: relative;
  color: var(--text_bg_color);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 0px 46px 0px #41548A4D;

  .dialog-content {
    overflow-y: auto;
    padding: px2rem(10) 0;
    // flex: 1;
    // min-height: px2rem(250);
    background: #F1F6FB;
    position: relative;
    top: px2rem(-12);
    border-radius: px2rem(12) px2rem(12) 0 0;
  }

  .dialog-title-notice {
    height: px2rem(110);
    flex-shrink: 0;
  }

  .dialog-main {
    padding: 0 px2rem(10);
  }

  // 轮播图片公告
  .van-swipe {
    height: px2rem(220);
    border-radius: px2rem(12);

    .van-image {
      display: block;
      width: 100%;
      height: 100%;
    }

    :deep(.van-swipe__indicators) {
      .van-swipe__indicator {
        background: #d9d9d9;
      }

      .van-swipe__indicator--active {
        background: var(--primary);
      }
    }
  }

  // 文字公告
  .notice-collapse-box {
    margin-top: px2rem(10);

    :deep(.van-cell:not(.van-collapse-item__title--expanded)) {
      .van-cell__right-icon {
        &:before {
          transform: initial;
        }
      }
    }

    :deep(.van-cell) {
      height: px2rem(40);

      &.van-collapse-item__title--expanded {
        color: var(--primary);

        .van-cell__right-icon {
          color: var(--primary);
        }
      }
    }

    .notice-item {
      border-radius: px2rem(10);
      margin-bottom: px2rem(8);
      overflow: hidden;
      border: px2rem(1) solid transparent;
      transition: .2s;

      &:last-child {
        margin-bottom: 0;
      }

      &:has(> .van-collapse-item__title--expanded) {
        border-color: var(--primary);
      }

      :deep(.van-collapse-item__content) {
        padding: px2rem(10);
        line-height: 1.4;
        font-size: px2rem(14);
        word-break: break-word;
      }
    }
  }

  .notic-footer {
    background: #fff;
    height: px2rem(28);
    padding: px2rem(10) px2rem(14);
    position: relative;
    top: px2rem(-12);
    border-radius: 0 0 px2rem(12) px2rem(12);
    flex-shrink: 0;
  }

  .readed-txt {
    color: var(--primary);
  }
}

.themeKY28 {
  .dialog-notice {
    .title-main {
      width: 100%;
      height: 100%;
      @include bgFull(publicImgUrl('themeKY28/home/notice_title.png'));
      background-size: 100% auto;
    }
  }
}

.themeKYMN {
  .dialog-notice {
    .dialog-title-notice {
      height: px2rem(52);
    }

    .title-main {
      width: 100%;
      height: 100%;
      @include bgFull(publicImgUrl('themeKYMN/home/notice_title.png'));
      background-size: 100% auto;
    }

    .dialog-content {
      top: px2rem(-1);
      border-radius: px2rem(3) px2rem(3) 0 0;
      background: linear-gradient(180deg, #FFF9F2, #fff);
    }

    .dialog-main {
      padding-top: px2rem(5);
    }

    .notice-collapse-box {
      .notice-title-icon {
        width: px2rem(20);
        height: px2rem(20);
        margin-right: px2rem(5);
        flex-shrink: 0;
        background: url(publicImgUrl('themeKYMN/home/notice_icon_2.png')) 0 0 / 100% 100%;
      }

      :deep(.van-cell) {
        background: #FAFAFA;
        height: px2rem(46);
        border-radius: px2rem(6);

        .van-cell__right-icon {
          @include flexStyle();
          width: px2rem(20);
          height: px2rem(20);
          background: #F5F5F5;
          color: #666;
          border-radius: 50%;
          font-size: px2rem(14);
          text-align: center;
          transition: .2s;
        }
      }

      .notice-item {
        border: 0;
        border-radius: 0;
      }

      :deep(.van-collapse-item__content) {
        border-top: 0;
      }

      :deep(.van-collapse-item__title--expanded) {
        background: #FEF3E7;
        color: #333;
        border-radius: px2rem(6) px2rem(6) 0 0;

        .van-cell__right-icon {
          background: #F6B168;
          color: #fff;
        }

        .notice-title-icon {
          background-image: url(publicImgUrl('themeKYMN/home/notice_icon_2.png'));
        }
      }
    }

    .notic-footer {
      top: px2rem(-2);
      height: px2rem(36);
    }

    .readed-txt {
      padding: px2rem(6) px2rem(15);
      background: var(--primary);
      color: #fff;
      border-radius: px2rem(5);
      height: px2rem(24);
      line-height: px2rem(24);
      text-align: center;
    }

    .notice-bottom {
      margin-top: px2rem(10);
      display: flex;
      align-items: center;
      flex-direction: column;

      .van-checkbox {
        margin-bottom: px2rem(10);

        :deep(.van-checkbox__icon) {
          font-size: px2rem(16);
          background: #EAEAEA;
        }

        :deep(.van-checkbox__label) {
          color: #fff;
        }
      }
    }
  }
}
</style>